import { render, staticRenderFns } from "./ColleagueSelect.vue?vue&type=template&id=32b548ee&scoped=true&"
import script from "./ColleagueSelect.vue?vue&type=script&lang=js&"
export * from "./ColleagueSelect.vue?vue&type=script&lang=js&"
import style0 from "./ColleagueSelect.vue?vue&type=style&index=0&id=32b548ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b548ee",
  null
  
)

export default component.exports